import { Link } from "react-router-dom";
import { BRAND } from "@/lib/api";
import { BackButton } from "@/components/BackButton";
import { Logo } from "@/components/Logo";
import { ExternalLink } from "lucide-react";

export const SiteFooter = () => (
  <footer className="border-t border-slate-800 px-6 py-10 lg:px-10">
    <div className="mx-auto flex max-w-7xl flex-col gap-4 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between">
      <span>© {new Date().getFullYear()} {BRAND.name} · Focused Laser Systems</span>
      <div className="flex gap-6">
        <a href={`mailto:${BRAND.email}`} data-testid="footer-email-link" className="hover:text-white">{BRAND.email}</a>
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy</Link>
        <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms</Link>
      </div>
    </div>
  </footer>
);

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["What we collect", "Your name, email, optional company and phone number, and the content you submit: tickets, community posts, marketplace listings and photos."],
      ["How we use it", "To provide support, reply to your tickets, show your community posts and listings, and let buyers contact sellers. We do not sell your data."],
      ["Marketplace contact details", "Contact details on listings are only shown to signed-in users."],
      ["Your rights", `You can ask us to access, correct or delete your data at any time by emailing ${BRAND.email}.`],
    ],
  },
  terms: {
    title: "Terms of Service",
    sections: [
      ["Using the service", "Keep your login details secure and only post accurate information about your machines and issues."],
      ["Community", "Be respectful. We may remove posts that are abusive, off-topic or unsafe."],
      ["Marketplace", "FLS Support Centre does not process payments and is not a party to any sale. Buyers and sellers deal directly and are responsible for their own transactions."],
      ["Contact", `Questions about these terms: ${BRAND.email}.`],
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind];
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200">
      <header className="mx-auto flex max-w-3xl items-center justify-between px-6 py-6">
        <BackButton />
        <div className="flex items-center gap-4"><a href={BRAND.mainSite} data-testid="legal-main-site-link" className="inline-flex items-center gap-1 text-sm text-slate-400 hover:text-white"><ExternalLink className="h-3.5 w-3.5" /> FLS main website</a><Logo testId="legal-logo-link" /></div>
      </header>
      <main className="mx-auto max-w-3xl px-6 pb-20 pt-10" data-testid={`legal-${kind}-page`}>
        <h1 className="font-heading text-4xl font-bold text-white sm:text-5xl">{c.title}</h1>
        <div className="laser-line mt-6 w-24" />
        <div className="mt-10 space-y-8">
          {c.sections.map(([h, p]) => (
            <section key={h}>
              <h2 className="font-heading text-lg font-semibold text-white">{h}</h2>
              <p className="mt-2 text-slate-400">{p}</p>
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
